<template>
  <div class="main-content main-content_vertical sent-paid-mode">
    <div class="wrapper">
      <div class="h1 h1-mob-lg">
        {{$t('success.thank_you_for_your_donation')}}
        <br />
        <p v-if="!donationOnlyMode">{{$t('success.your_effect_will_appear_on_the_stream_within_a_minute')}}</p>
      </div>
      <div class="btns">
        <router-link to="/" class="black-link">{{$t('success.go_back')}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
  name: 'PaymentSuccess',
  methods: {
    ...mapMutations(['setPaymentMode'])
  },
  mounted() {
    this.setPaymentMode('donation');
  },
  computed: {
    donationOnlyMode() {
      return this.$store.getters.donationOnlyMode;
    },
  }
};
</script>
